
import React from 'react';
import { IonItem, IonLabel, IonChip, IonIcon } from '@ionic/react';
import { star } from 'ionicons/icons';


class RunewordListItem extends React.Component {
  render() {
    const favRunewords = JSON.parse(localStorage.getItem('favRunewords'));
    return (
      <IonItem routerLink={'/runewords/'+this.props.runeword.id}>
        <IonLabel>
          <h1>{this.props.runeword.name}</h1>
          <p>
            {this.props.runeword.runes.length } socket {this.props.runeword.itemType}
          </p>
        </IonLabel>
        {favRunewords.includes(this.props.runeword.name) && <IonIcon slot="end" style={{}} color="secondary" icon={star}/>}
        {this.props.runeword.popular && <IonChip>popular</IonChip>}
        {this.props.runeword.new && <IonChip>new</IonChip>}
        {(this.props.runeword.ladderOnly || this.props.runeword.ladder) && <IonChip>ladder</IonChip>}
      </IonItem>
    );
  }
}

export default RunewordListItem;